<p-dialog [(visible)]="display" [modal]="true" [style]="{width: '80vw'}" [blockScroll]="true" 
class="no-padding-top custom-modal-header" [closable]="true" (onHide)="onClose('cancel')">
    <ng-template pTemplate="header">
        <!-- <div class="p-d-flex p-jc-between w-100">
            <h5 class="p-mb-0">{{depositHeader}}</h5>
            <div *ngIf="statementMessage">
                <strong [ngClass]="'status-open'">{{statementMessage}}</strong>
            </div>
            <span *ngIf="type === 'VIEW' && !isVoided"  class="btnBars" (click)="viewToEditDeposit()">
                <i class="pi pi-pencil"></i>
            </span>
        </div> -->
        <form [formGroup]="depositForm" class="w-100">
            <div class="p-grid w-100">
                <div class="p-col-12 p-md-3">
                    <div class="p-d-flex">
                        <label class="p-mr-2" style="white-space: nowrap;">Deposit To</label>
                        <liono-treeSelect class="border-bottom-input w-100" [options]="banks" appendTo="body" placeholder="Select a Bank" formControlName="depositToBankFinancialAccountId" 
                            display="comma" [metaKeySelection]="false" selectionMode="single" style="overflow:hidden">
                        </liono-treeSelect>
                    </div>
                </div>
                <div class="p-col-12 p-md-2">
                    <div class="p-d-flex">
                        <label class="p-mr-2">Date</label>
                        <p-calendar [showIcon]="true" inputId="icon" appendTo="body" formControlName="depositDate" class="w-100 p-mr-2"></p-calendar>
                    </div>
                </div>
                <div class="p-col-12 p-md-3" *ngIf="isAllowPostingPeriod">
                    <div class="p-d-flex">
                        <label class="p-mr-2" style="white-space: nowrap;">Posting Period:<span style="color: red">*</span></label>
                        <app-posting-period-selector style="overflow:hidden" class="w-100"
                            [transactionDate]="depositForm?.get('depositDate')?.value" [isViewMode]="type === 'VIEW'"
                            [selectedPostingPeriod]="currentPostingPeriodInfo" [moduleName]="'Deposit'"
                            (postingInfoChange)="onPostingInfoChange($event)">
                        </app-posting-period-selector>
                    </div>
                </div>
                <div class="p-col-12" [ngClass]="isAllowPostingPeriod ? 'p-md-2' : 'p-md-4'">
                    <div class="p-d-flex">
                        <label class="p-mr-2">Memo</label>
                        <input type="text" pInputText formControlName="memo" class="w-100">
                    </div>
                </div>
                <div class="p-col-12" [ngClass]="isAllowPostingPeriod ? 'p-md-2' : 'p-md-3'">
                    <div class="p-d-flex p-jc-between">
                        <div *ngIf="statementMessage">
                            <strong [ngClass]="'status-open'">{{statementMessage}}</strong>
                        </div>
                        <div class="p-d-flex p-jc-end p-ai-center" style="width: 100%;">
                            <span *ngIf="type === 'VIEW' && !isVoided && isEditableViewDialog" class="btnBars" (click)="viewToEditDeposit()">
                                <i class="pi pi-pencil"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </ng-template>
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <p class="p-mt-3">Click Payments to select customer payments that you have received. List any other amounts to deposit below.</p>
            </div>
        </div>
        <div class="p-grid" *ngIf="pageIndex==1">
            <div class="p-col-12">
                <p-table [value]="paymentsTB" [(selection)]="selectedPayments" [scrollable]="true" scrollHeight="400px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 4rem">
                                <p-tableHeaderCheckbox [disabled]="type === 'VIEW'" (click)="onTableCheckboxToggle()"></p-tableHeaderCheckbox>
                            </th>
                            <th>Date</th>
                            <th>Received From</th>
                            <th>From Account</th>
                            <th>Memo</th>
                            <th>Ref No.</th>
                            <th>PMT Method</th>
                            <th>Amount ({{currencySymbol}})</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                        <tr class="p-selectable-row">
                            <td>
                                <p-tableCheckbox [value]="product" [disabled]="type === 'VIEW'" (click)="onTableCheckboxToggle()"></p-tableCheckbox>
                            </td>
                            <td>{{product.paymentDate | localDate:'MM/DD/YYYY'}}</td>
                            <td>{{product.accountName}}</td>
                            <td>{{product.fromFinancialAccountName}}</td>
                            <td>{{product.memo}}</td>
                            <td>{{product.checkNo}}</td>
                            <td>{{product.methodName}}</td>
                            <td>{{product.amount | customNumberFormat: fractionDigits}}</td>
                            
                        </tr>
                    </ng-template>
                    
                </p-table>
            </div>
        </div>
        <div class="p-grid" *ngIf="pageIndex==2">
            <div class="p-col-12">
                <p-table [value]="dataList" [(selection)]="selectedPayments" [scrollable]="true" scrollHeight="400px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 4rem">
                                <p-tableHeaderCheckbox [disabled]="type === 'VIEW'" (click)="onTableCheckboxToggle()"></p-tableHeaderCheckbox>
                            </th>
                            <th>Date</th>
                            <th>Received From</th>
                            <th>From Account</th>
                            <th>Memo</th>
                            <th>Ref No.</th>
                            <th>PMT Method</th>
                            <th>Amount ({{currencySymbol}})</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                        <tr class="p-selectable-row">
                            <td>
                                <p-tableCheckbox [value]="product" [disabled]="type === 'VIEW'" (click)="onTableCheckboxToggle()"></p-tableCheckbox>
                            </td>
                            <td>{{product.paymentDate | localDate:'MM/DD/YYYY'}}</td>
                            <td>{{product.accountName}}</td>
                            <td>{{product.fromFinancialAccountName}}</td>
                            <td>{{product.memo}}</td>
                            <td>{{product.checkNo}}</td>
                            <td>{{product.methodName}}</td>
                            <td>{{product.amount | customNumberFormat: fractionDigits}}</td>
                            
                        </tr>
                    </ng-template>
                    
                </p-table>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="p-mb-3">
            <p-table>
                <ng-template pTemplate="footer">
                    <tr>
                        <td class="p-col-10 p-text-right">Deposit Total</td>
                        <td class="p-col-2">
                            {{totalAmt | customNumberFormat: fractionDigits | currencySymbol}}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <p-button label="Back" (click)="pageIndex=1" *ngIf="pageIndex==2"></p-button>
        <button *ngIf="type == 'VIEW' && isShowVoidDelete" type="button" pButton label="Void" [disabled]="isVoided" (click)="voidOrDelete(true)" class="p-mr-2"></button>
        <p-button *ngIf="type == 'VIEW' && isShowVoidDelete" [label]="'Delete'" styleClass="p-button-danger" (click)="voidOrDelete(false)" class="p-mr-2"></p-button>
        <p-button (click)="onClose('cancel')" label="Cancel" styleClass="p-button-secondary"></p-button>
        <p-button (click)="next()" label="Next" 
        [disabled]="selectedPayments?.length == 0 || !depositForm?.controls?.depositToBankFinancialAccountId?.value?.value?.id || !!statementMessage" 
        *ngIf="type != 'VIEW' && pageIndex==1"></p-button>
        <p-button (click)="save()" label="Save" 
        [disabled]="(isAllowPostingPeriod && !updatedPostingPeriodInfo?.postingDate) ||selectedPayments?.length == 0 || !depositForm?.controls?.depositToBankFinancialAccountId?.value?.value?.id || !!statementMessage" 
        *ngIf="type != 'VIEW' && pageIndex==2"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="Deposit Details" [(visible)]="displayDetails" [modal]="true" [responsive]="true" [style]="{width: '50vw'}">
    <form [formGroup]="depositDetailForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12 p-d-flex">
                    <div class="p-field-radiobutton p-mb-0">
                        <p-radioButton name="customer" value="customer" [(ngModel)]="payTo" inputId="customer" [ngModelOptions]="{standalone: true}"></p-radioButton>
                        <label for="customer">Customer</label>
                    </div>
                    <div class="p-field-radiobutton p-mx-3 p-mb-0">
                        <p-radioButton name="vendor" value="vendor" [(ngModel)]="payTo" inputId="vendor" [ngModelOptions]="{standalone: true}"></p-radioButton>
                        <label for="vendor">Vendor</label>
                    </div>
                </div>
            </div>
            <div class="p-grid" *ngIf="payTo == 'vendor'">
                <div class="p-col-12 p-md-6">
                    <label>Vendor</label>
                    <p-dropdown [options]="allVendorsDD" [filter]="true" optionLabel="name" placeholder="Select Vendor" appendTo="body" formControlName="vendorId" (onChange)="getSelectedVendorDetails()"></p-dropdown>
                </div>
            </div>
            <div class="p-grid" *ngIf="payTo == 'customer'">
                <div class="p-col-12 p-md-6">
                    <label>Channel</label>
                    <p-dropdown [options]="accountChannels" optionLabel="name" appendTo="body" [filter]="true" formControlName="accountChannelId" (onChange)="onChangeAccountChannel()"></p-dropdown>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Account</label>
                    <p-autoComplete [suggestions]="allAccountsDD" (completeMethod)="filterAccount($event)" field="businessName" [minLength]="1" placeholder="Search Account..." appendTo="body" (onSelect)="selectAccount($event.value)" formControlName="accountId"></p-autoComplete>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Finance Account</label>
                    <liono-treeSelect class="border-bottom-input" [options]="financialAccounts" appendTo="body" placeholder="Select Financial Account" display="comma" formControlName="toFinancialAccountId" [metaKeySelection]="false" selectionMode="single"></liono-treeSelect>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Reference No.</label>
                    <input type="text" pInputText formControlName="checkNo">
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Payment Method</label>
                    <p-dropdown [options]="vendorPaymentMethodsDD" optionLabel="paymentMethodMethod" placeholder="Select Payment Method" [showClear]="true" [filter]="true" appendTo="body" formControlName="paymentMethodId" *ngIf="payTo == 'vendor'"></p-dropdown>

                    <p-dropdown [options]="allPaymentMethods" optionLabel="name" placeholder="Select Payment Method" [showClear]="true" [filter]="true" appendTo="body" formControlName="paymentMethodId" *ngIf="payTo == 'customer'"></p-dropdown>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Amount ({{currencySymbol}})</label>
                    <p-inputNumber mode="decimal" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" formControlName="amount"></p-inputNumber>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12">
                    <label>Memo</label>
                    <textarea rows="5" cols="30" pInputTextarea formControlName="memo"></textarea>
                </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="displayDetails = false;" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton (click)="saveDetail()" class="p-button-success" label="Save"></button>
    </p-footer>
</p-dialog>

<!-- closing statement -->
<ng-container *ngIf="display">
    <app-closing-statement-validation
        [isClosingDate]="isAllowPostingPeriod ? (updatedPostingPeriodInfo?.postingDate ?? currentPostingPeriodInfo?.postingDate ?? null) : depositForm?.controls?.depositDate.value" 
        [moduleName]="'Deposit'" (isClosingStatementDate)="isClosingStatementDate($event)">
    </app-closing-statement-validation>
</ng-container>